<template>
  <div class="outer-wrap">
    <div class="dark-overlay"></div>
    <div id="monitor-outerwrap">
      <div class="monitor-container" v-if="selectedSensor">
        <!-- Loading -->
        <transition name="load">
          <SmallLoadingLogo v-if="!this.loaded" />
        </transition>
        <!-- Heading -->
        <div id="monitor-header" class="noselect">
          <h1>{{ "Nodo Analogico" }}</h1>
          <a @click="closeMe" class="close"></a>
        </div>
        <!-- Opzioni sulla sinistra -->
        <div id="side-options" class="noselect">
          <div class="options">
            <a
              v-for="sensor in tempSensors"
              :key="sensor.eui"
              @click="
                selectedSensor = sensor;
                curTab = 'manage';
              "
              :class="{ active: selectedSensor && selectedSensor.eui === sensor.eui }"
              >{{ sensor.eui.substr(sensor.eui.length - 4) }}
            </a>
          </div>
        </div>
        <!-- Tabs -->
        <div id="tab">
          <a @click="curTab = 'manage'" :class="{ active: curTab === 'manage' }">{{ "Gestisci" }} </a>
          <a
            v-for="(channel, index) in selectedSensor.userConfig.channels"
            @click="channel.enabled ? (curTab = index) : null"
            :key="index"
            :class="{ active: curTab === index, disabled: !channel.enabled }"
            >{{ channel.name }}</a
          >
        </div>

        <!-- Contento principale   -->
        <div id="main-content">
          <!-- Stato -->
          <div v-if="this.curTab === 'manage'">
            <div class="sr-heading">
              <p>{{ "Gestisci le impostazioni di funzionamento del Nodo Analogico:" }}:</p>
            </div>
            <div id="sr-content">
              <div class="sensor-manage-box">
                <!-- Colore -->
                <div class="side-color" :style="{ backgroundColor: selectedSensor.userConfig.color }"></div>
                <!-- Titolo -->
                <div class="sensor-head">
                  <h5>{{ "Nodo Analogico " + selectedSensor.eui + " - " + selectedSensor.userConfig.name }}</h5>
                  <!-- <input
                      type="text"
                      class="sensor-manage-threshold"
                      spellcheck="false"
                      v-model="selectedSensor.name"
                      :disabled="false"
                    /> -->
                </div>
                <!-- Form -->
                <div class="sensor-params">
                  <div class="threshold-field">
                    <label>{{ "Tempo di acquisizione" }}</label>
                    <input
                      type="number"
                      min="0"
                      step="any"
                      class="sensor-manage-threshold"
                      spellcheck="false"
                      maxlength="10e"
                      v-model.number="selectedSensor.userConfig.acquisitionTime"
                      :disabled="false"
                    />
                    <label>{{ "Tempo di warmup" }}</label>
                    <input
                      type="number"
                      min="0"
                      step="any"
                      class="sensor-manage-threshold"
                      spellcheck="false"
                      maxlength="10e"
                      v-model.number="selectedSensor.userConfig.warmupTime"
                      :disabled="false"
                    />
                  </div>
                </div>
                <!-- Icone modifica -->
                <!-- <img
                  class="sensor-manage-edit icon"
                  src="../../public/assets/icons/edit.svg"
                  @click="editUserConfig(sensor)"
                /> -->
                <img class="sensor-manage-changecolor icon" src="../../public/assets/icons/changecolor.svg" />
                <div class="dropdown">
                  <div class="dropdown-content">
                    <div
                      v-for="(color, key, index) in colors"
                      :key="index"
                      class="dot"
                      :style="{ backgroundColor: color }"
                      @click="selectedSensor.userConfig.color = color"
                    ></div>
                  </div>
                </div>
              </div>
              <!-- Selezione sotto-sensori -->
              <div class="sensor-selection">
                <div class="checkbox" v-for="(channel, index) in selectedSensor.userConfig.channels" :key="index">
                  <input type="checkbox" :name="'channel' + index" v-model="channel.enabled" />
                  <label>{{ "Sensore " + (index + 1) }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="sr-heading">
              <p>{{ "Configura il dispositivo collegato al Nodo Analogico" }}:</p>
              <h2>
                {{ selectedSensor.userConfig.name + " - Nodo Analogico " + selectedSensor.eui.substr(selectedSensor.eui.length - 4) }}:
              </h2>
            </div>
            <div class="device-settings">
              <!-- Nome canale -->
              <div class="single-setting">
                <label>Ch. name</label>
                <input
                  type="text"
                  class="sensor-manage-threshold"
                  spellcheck="false"
                  maxlength="12"
                  v-model="selectedSensor.userConfig.channels[curTab].name"
                  :disabled="false"
                />
              </div>
              <!-- Type -->
              <div class="single-setting">
                <label>Type</label>
                <select class="select" v-model="selectedSensor.userConfig.channels[curTab].type" :disabled="false">
                  <option v-for="chType in actualTypes" :key="chType" :value="chType">{{ chType }}</option>
                </select>
              </div>
              <!-- Wires -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].wires">
                <label>Wires</label>
                <select class="select" v-model.number="selectedSensor.userConfig.channels[curTab].wires">
                  <option
                    :value="wireOption"
                    v-for="(wireOption, index) in options[selectedSensor.userConfig.channels[curTab].type].wires"
                    :key="index"
                  >
                    {{ wireOption }}
                  </option>
                </select>
              </div>
              <!-- SensorType -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].sensorType">
                <label>Sensor Type</label>
                <select class="select" v-model.number="selectedSensor.userConfig.channels[curTab].sensorType">
                  <option
                    :value="sensrType"
                    v-for="(sensrType, index) in options[selectedSensor.userConfig.channels[curTab].type].sensorType"
                    :key="index"
                  >
                    {{ sensrType }}
                  </option>
                </select>
              </div>
              <!-- VCC -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].VCC">
                <label>VCC</label>
                <select class="select" v-model.number="selectedSensor.userConfig.channels[curTab].VCC">
                  <option :value="0">0</option>
                  <option :value="5">5</option>
                  <option :value="12">12</option>
                  <option :value="24">24</option>
                </select>
              </div>
              <!-- Full Scale -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].fullScale">
                <label>Full Scale</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  class="sensor-manage-threshold"
                  spellcheck="false"
                  maxlength="10e"
                  v-model.number="selectedSensor.userConfig.channels[curTab].fullScale"
                  :disabled="false"
                />
              </div>
              <!-- Offset -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].offset">
                <label>Offset</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  class="sensor-manage-threshold"
                  spellcheck="false"
                  maxlength="10e"
                  v-model.number="selectedSensor.userConfig.channels[curTab].offset"
                  :disabled="false"
                />
              </div>
              <!-- Max Value -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].maxValue">
                <label>Max Value</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  class="sensor-manage-threshold"
                  spellcheck="false"
                  maxlength="10e"
                  v-model.number="selectedSensor.userConfig.channels[curTab].maxValue"
                  :disabled="false"
                />
              </div>
              <!-- Gain -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].gain">
                <label>Gain</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  class="sensor-manage-threshold"
                  spellcheck="false"
                  maxlength="10e"
                  v-model.number="selectedSensor.userConfig.channels[curTab].gain"
                  :disabled="false"
                />
              </div>
              <!-- Nominal Resistance -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].nominalResistance">
                <label>Nominal Res.</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  class="sensor-manage-threshold"
                  spellcheck="false"
                  maxlength="10e"
                  v-model.number="selectedSensor.userConfig.channels[curTab].nominalResistance"
                  :disabled="false"
                />
              </div>
              <!-- Unità di Misura -->
              <div class="single-setting" v-if="options[selectedSensor.userConfig.channels[curTab].type].mesUnit">
                <label>Mes. Unit</label>
                <input
                  type="text"
                  class="sensor-manage-threshold"
                  spellcheck="false"
                  v-model="selectedSensor.userConfig.channels[curTab].mesUnit"
                  :disabled="false"
                />
              </div>
              <!-- Allarmi -->
              <div class="sep multiple-control" v-if="false">
                <h2>Allarme</h2>
                <div class="sub-setting">
                  <div class="auto-row">
                    <label>Attivato</label>
                    <input type="checkbox" v-model="selectedSensor.userConfig.channels[curTab].alertOn" />
                  </div>
                  <div class="auto-row">
                    <label>Valore Assoluto</label>
                    <input
                      class="checkbox"
                      type="checkbox"
                      v-model="selectedSensor.userConfig.channels[curTab].alertAbsolute"
                    />
                  </div>
                </div>
                <div class="single-setting large">
                  <label>Soglia</label>
                  <input
                    type="number"
                    class="sensor-manage-threshold"
                    spellcheck="false"
                    v-model.number="selectedSensor.userConfig.channels[curTab].alertThreshold"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div id="footer">
          <div class="footer-btn">
            <button type="button" class="button" @click="closeMe">
              {{ $t("message.undo") }}
            </button>
            <button type="button" class="button save" @click="saveAllSettings">
              {{ $t("message.saveChanges") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../services/api";
import SmallLoadingLogo from "../components/ui/SmallLoadingLogo";
import $ from "jquery";

export default {
  name: "analog-node",
  props: {
    selectedStructure: Object,
  },
  components: {
    SmallLoadingLogo,
  },
  data() {
    return {
      actualTypes: [
        "4-20",
        "gestecno",
        "thermistorPT100_620",
        "thermistorPT100_680",
        "mV/V",
        "potentiometer",
        "voltage-unipolar",
        "voltage-bipolar",
      ],
      options: {
        "4-20": {
          wires: [2, 3],
          VCC: 5,
          fullScale: 5,
          offset: 1,
          mesUnit: "mm",
        },
        gestecno: {
          wires: [2, 3],
          VCC: 5,
          fullScale: 5,
          offset: 1,
          mesUnit: "mm",
        },
        thermistorPT100_620: {
          sensorType: ["NTC", "PTC"],
          gain: 5,
          offset: 1,
          mesUnit: "°C",
        },
        thermistorPT100_680: {
          sensorType: ["NTC", "PTC"],
          gain: 5,
          offset: 1,
          mesUnit: "°C",
        },
        "mV/V": {
          VCC: 5,
          gain: 5,
          offset: 1,
          fullScale: 5,
          mesUnit: "mm",
        },
        potentiometer: {
          VCC: 5,
          fullScale: 5,
          offset: 1,
          mesUnit: "mm",
        },
        "voltage-unipolar": {
          VCC: 5,
          fullScale: 5,
          offset: 1,
          mesUnit: "mm",
        },
        "voltage-bipolar": {
          fullScale: 5,
          offset: 1,
          mesUnit: "mm",
        },
      },
      needPageRefresh: false,
      tempSensors: [],
      loaded: true,
      selectedSensor: null,
      curTab: "manage",
      selectedChannel: 1,
      colors: ["white", "silver", "gray", "black", "red", "yellow", "green", "aqua", "blue", "navy", "fuchsia", "purple"],
    };
  },
  methods: {
    async saveAllSettings() {
      this.loaded = false;
      //this.$emit('save-settings', this.tempSensors);
      let res2 = await api.saveSensorsSettings({
        sensors: this.tempSensors.map((sensor) => ({
          eui: sensor.eui,
          type: sensor.type,
          rev: sensor.rev,
          userConfig: sensor.userConfig,
        })),
      });
      console.log(res2);
      this.loaded = true;
      this.needPageRefresh = true;
      this.closeMe();
    },
    closeMe() {
      this.$emit("close-me");
    },
  },
  watch: {
    selectedSensor: {
      handler(newSensor) {
        if (this.selectedSensor && newSensor && this.curTab != "manage" && this.options[newSensor.userConfig.channels[this.curTab].type]) {
          //this.selectedSensor.userConfig.channels[this.curTab] = {}
        }
        //this.selectedSensor.userConfig.channels[this.curTab] = this.options[newSensor.userConfig.channels[this.curTab].type]
      },
      deep: true,
    },
  },
  async mounted() {
    this.tempSensors = JSON.parse(JSON.stringify(this.selectedStructure.sensors.filter((sensor) => sensor.type === "analog-node")));
    this.selectedSensor = this.tempSensors[0];
    $(document.body).addClass("modal-open"); // Blocco scorrimento body
    this.loaded = true;
  },
  async beforeDestroy() {
    $(document.body).removeClass("modal-open"); // Consento al body di scorrere di nuovo
    if (this.needPageRefresh) {
      this.$emit("need-refresh");
    }
  },
};
</script>
<style lang="postcss" scoped>
* {
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  color: white;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  -khtml-user-select: text; /* Konqueror HTML */
  -moz-user-select: text; /* Old versions of Firefox */
  -ms-user-select: text; /* Internet Explorer/Edge */
  user-select: text; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}
select {
  margin: 0;
  padding: 0 6px;
  width: 100%;
}
.dark-overlay {
  background-color: rgba(0, 0, 0, 0.27);
  width: 100%;
  height: 100%;
  position: absolute;
}
body {
  background-color: white !important;
}

h1 {
  font-size: 1.3em;
}
h2{
  text-align: left;
  font-weight: 700;
}
h5 {
  margin: 0;
  font-weight: 700;
}
p {
  font-size: 0.8em;
  color: rgb(198, 198, 198);
  padding: 0px;
}
.horiz-divider {
  background-color: grey;
  height: 2px;
}
/* .input-text {
  background-color: rgba(0, 0, 0, 0);
  width: 120px;
  font-size: 1em;
  outline-width: 0;
  outline: none !important;
  border: none;
  display: inline;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  padding-bottom: 1%;
  white-space: nowrap;
  display: flex;
  align-items: center;
  align-self: center;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
} */
.input-text:enabled {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}
.input-text:invalid {
  border: solid 1.2px red;
  padding: 1px;
}
.input-text:valid {
  border: solid 1.2px green;
  padding: 1px;
}
.monitor-container {
  width: 55vw;
  height: 64vh;
  min-width: 840px;
  min-height: 400px;
  top: 22vh;
  left: 0;
  position: sticky;
  grid-template-columns: 1.6fr 8.4fr;
  grid-template-rows: 1fr 1.1fr 6.9fr 1fr;
  border-radius: 10px;
  overflow: hidden;
  display: grid;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
}
.options {
  height: 100%;
  display: grid;
  text-align: left;
  padding-top: 0.8vw;
  height: 40%;
  display: grid;
  text-align: left;
  grid-template: none;
  border-top: solid 2px grey;
  align-items: center;
}
.options > a {
  padding-left: 1.2vw;
  font-size: 0.95em;
  height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
/* selected link */
.options > a.active {
  background-color: rgb(32, 34, 47);
}
.options > a.disabled {
  color: gray;
  pointer-events: none;
  cursor: default;
}
#monitor-header {
  background-color: rgb(45, 48, 65);
  height: 100%;
  min-height: 45px;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row: 1;
  z-index: 11;
  display: flex;
  align-items: center;
  padding-left: 1.2vw;
  border-bottom: solid 2px white;
}
#side-options {
  height: 100%;
  min-width: 120px;
  background-color: rgb(45, 48, 65);
  grid-row-start: 2;
  grid-row-end: 5;
  grid-column: 1;
  z-index: 10;
  position: relative;
  border-right: solid 2px white;
  display: grid;
  grid-template-rows: auto;
}
#main-content {
  background-color: rgb(45, 48, 65);
  grid-row: 3;
  grid-column: 2;
  padding-left: 4%;
  padding-right: 4%;
  padding-top: 1.8vw;
  padding-bottom: 40px;
  overflow-y: scroll;
  overflow-x: hidden;
  /*   -webkit-box-shadow: inset 0px 16px 8px -10px rgba(0, 0, 0, 0.4), inset 0px -16px 6px -10px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: inset 0px 16px 8px -10px rgba(0, 0, 0, 0.4), inset 0px -16px 6px -10px rgba(0, 0, 0, 0.4);
  box-shadow: inset 0px 16px 8px -10px rgba(0, 0, 0, 0.4), inset 0px -16px 6px -10px rgba(0, 0, 0, 0.4); */
}
.single-setting {
  max-width: 500px;
  display: grid;
  grid-template-columns: 140px 10fr;
  justify-items: baseline;
  align-items: center;
  padding: 5px 0;
  height: 30px;
}
.single-setting > label {
  grid-row: 1;
}
.auto-row{
  max-width: 500px;
  height: 30px;
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#tab {
  background-color: rgb(45, 48, 65);
  grid-row: 2;
  width: 100%;
  border-bottom: solid 1px gray;
  align-items: center;
  display: grid;
  grid-auto-rows: 100%;
  z-index: 9;
  grid-template-columns: 10fr repeat(4, 20%);
  -webkit-box-shadow: 1px - 10px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 1px 8px 10px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 1px 8px 10px 0px rgba(0, 0, 0, 0.4);
}
#tab > a {
  white-space: nowrap;
  align-self: center;
  cursor: default;
  font-size: 0.9em;
  margin-left: 10%;
  margin-right: 10%;
  align-self: end;
  font-weight: 600;
  font-size: 0.8em;
  padding-bottom: 7px;
  padding-top: 7px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
#tab > a:hover {
  background-color: rgb(80, 84, 105);
}
#tab > a.active {
  border-bottom: solid 3px rgb(21, 146, 230);
  padding-bottom: 4px;
  color: rgb(21, 146, 230);
}
#tab > a.disabled {
  color: gray;
  pointer-events: none;
  cursor: default;
}
#footer {
  background-color: rgb(45, 48, 65);
  border-top: solid 0.8px gray;
  height: 100%;
  grid-column: 2;
  grid-row: 4;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  -webkit-box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
}
#sr-content {
  /* padding-bottom: 20px; */
  background-color: rgb(80, 84, 105);
  border-radius: 10px;
  padding: 0 10px;
  /* height: fit-content; */
}
.sensor-selection {
  display: flex;
  justify-content: space-between;
  padding: 14px 30px;
}
.checkbox {
  display: flex;
  align-items: center;
}
.checkbox > input[type="checkbox"] {
  margin-right: 10px;
}
input[type="checkbox"] {
  height: 18px;
  width: 18px;
}
.sr-heading {
  text-align: left;
  margin-bottom: 25px;
}
.sr-heading > h4 {
  margin: 0;
}
.sr-heading > p {
  margin: 0;
}
.checkbox-container {
  display: grid;
  width: 100%;
  justify-items: center;
}
.info-container {
  grid-row: 2;
  grid-column: 2;
  display: grid;
  grid-template-columns: repeat(4, 25%);
  align-content: center;
  text-align: center;
}
.sensor-box {
  height: 80px;
  text-align: left;
  border-bottom: solid 1px grey;
  display: grid;
  padding-bottom: 10px;
  grid-template-columns: 2% 98%;
  grid-template-rows: auto 60%;
}
.sensor-head {
  margin: 0;
  margin-top: 10px;
  grid-column: 2;
  grid-row: 1;
  display: flex;
}
.value {
  font-weight: 700;
}
.sensor-box > .sensor-caption {
  margin: 0;
  grid-column: 2;
  grid-row: 2;
}

.sensor-manage-box {
  height: fit-content;
  text-align: left;
  border-bottom: solid 2px rgba(255, 255, 255, 0.15);
  padding-bottom: 20px;
  display: grid;
  grid-template-columns: 2% 60% 20% 9% 9%;
  grid-template-rows: 40px min-content min-content;
  padding-top: 1%;
}
label {
  white-space: nowrap;
  font-weight: 500;
}
.sensor-manage-box > .sensor-manage-eui {
  margin: 0;
  white-space: nowrap;
  font-weight: 700;
  font-size: 0.9em;
  align-self: center;
  padding-top: 1%;
  grid-column: 2;
  grid-row: 1;
}
.sensor-manage-name {
  grid-column: 2;
  grid-row: 2;
}
.sensor-params {
  width: fit-content;
  grid-column: 2;
  grid-row: 2;
}
.threshold-field {
  display: grid;
  row-gap: 10px;
}
.threshold-field > label {
  grid-column: 1;
  font-weight: 400;
  font-size: 0.8em;
  align-self: center;
  margin: 0;
  padding: 0;
}
input[type="number"],
input[type="text"] {
  background-color: rgba(0, 0, 0, 0);
  padding-left: 6px;
  width: 100%;
  height: 100%;
  font-size: 1em;
  outline-width: 0;
  box-sizing: border-box;
  outline: none !important;
  border: none;
  display: inline;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  display: flex;
  align-items: center;
  align-self: center;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
}
.threshold-field > input[type="number"] {
  grid-column: 2;
  margin-left: 10px;
}
input[type="number"],
input[type="text"]:enabled {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}
.sensor-manage-box > .sensor-manage-label {
  margin: 0;
  grid-row: 1;
  grid-column: 3;
  align-self: center;
}
.sensor-manage-box > .sensor-manage-edit {
  justify-self: end;
  align-self: end;
  grid-row: 1;
  grid-column: 5;
}
.sensor-manage-box > .sensor-manage-changecolor {
  justify-self: end;
  align-self: end;
  grid-row: 1;
  grid-column: 4;
}
.side-color {
  width: 6px;
  height: 80%;
  align-self: center;
  grid-column: 1;
  background-color: green;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  align-items: center;
  margin-left: -10px;
}
.multiple-control {
  display: grid;
  width: 500px;
  padding: 5px 0;
}
.sub-setting{
  display: flex;
  justify-content: space-between;
}

.sep {
  margin-top: 10px;
  border-top: solid grey 1px;
}
/* Mail */
.mail-box {
  height: 80px;
  text-align: left;
  border-bottom: solid 2px rgb(80, 84, 105);
  display: grid;
  grid-template-columns: 80% 10% 10%;
}
.mail-box > .input-text {
  width: 100%;
}
.notify-heading {
  text-align: left;
  padding-bottom: 15px;
  margin-bottom: 10px;
  border-bottom: solid 2px rgb(80, 84, 105);
}
.notify-heading > h4 {
  margin: 0;
}
.notify-heading > p {
  margin: 0;
}

::-webkit-scrollbar {
  width: 0.5em;
}
::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.close {
  align-self: center;
  cursor: pointer;
  right: 2%;
  width: 3%;
}
input[type="range"]::-moz-range-track {
  padding: 0 10px;
  background: repeating-linear-gradient(to right, #ccc, #ccc 10%, #000 10%, #000 11%, #ccc 11%, #ccc 20%);
}

/* Control Buttons */
.footer-btn {
  display: flex;
  height: 35px;
}
.button {
  width: 158px;
  font-size: 0.8em;
  padding: 2%;
  line-height: 100%;
  margin: auto;
  font-weight: 600;
  margin-right: 20px;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: rgb(80, 84, 105);
  border: solid 2px white;
  border-radius: 7px;
  transition: transform 0.1s linear;
}
.button:active {
  background-color: rgb(47, 112, 177);
  transform: translateY(1px);
}
.button:disabled {
  background-color: grey;
}
.button:disabled:hover {
  background-color: grey;
}
.bottom-buttons {
  position: absolute;
  top: 405px;
  left: 458px;
}
.save {
  background-color: rgb(21, 146, 230);
}
.save:hover {
  background-color: rgba(21, 146, 230, 0.8);
}
/* Color Dropdown */
.dropbtn {
  background-color: #4caf50;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}
.dropdown {
  position: relative;
  grid-row: 1;
  grid-column: 4;
}
.dropdown-content {
  transition: visibility 0.2s linear, opacity 0.2s linear;
  -ms-transition: visibility 0.2s linear, opacity 0.2s linear;
  -webkit-transition: visibility 0.2s linear, opacity 0.2s linear;
  display: grid;
  visibility: hidden;
  opacity: 0;
  align-content: center;
  align-items: center;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-rows: 33% 33% 33%;
  position: relative;
  top: -50%;
  right: 74px;
  background-color: rgb(80, 84, 105);
  width: 100px;
  height: 85px;
  border-radius: 5px;
  padding: 5px;
  transition-delay: 0.2s;
}
.dot {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  border: solid 1px white;
}
.dropdown:hover .dropdown-content {
  opacity: 1;
  visibility: visible;
}

/* Edit Icon */
.icon {
  padding: 5px;
  border-radius: 5px;
  -webkit-transition: background-color 100ms linear;
  -ms-transition: background-color 100ms linear;
  transition: background-color 100ms linear;
}
.icon:hover {
  background-color: rgb(80, 84, 105);
}
/* The container */
.container {
  position: relative;
  display: contents;
  cursor: pointer;
  font-size: 22px;
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
/* Hide the browser's default radio button */
.container input {
  position: absolute;
  top: 50vh;
  opacity: 0;
  cursor: pointer;
}
/* Create a custom radio button */
.checkmark {
  left: 0;
  top: 0;
  height: 14px;
  position: relative;
  width: 14px;
  border-radius: 50%;
  border: solid 3px white;
}
/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: rgb(80, 84, 105);
}
/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  /* background-color: #2196F3; */
}
/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}
/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
#monitor-outerwrap {
  z-index: 16;
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

#monitor-outerwrapheader {
  cursor: move;
}

/* Overlay Info */
.infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-radius: 10px;
  background-color: black;
  opacity: 0.7;
  z-index: 10;
}
.infoi > h2 {
  margin: auto;
  font-weight: 500;
}

/* Loading Transition */
.load-enter,
.load-leave-to {
  opacity: 0;
}
.load-enter-active {
  transition: all 0.1s ease;
}
.load-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
</style>
